<template>
  <div class="app flex-row align-items-center" style="background-color: #f6f6f6 !important;">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6">
          <b-card no-body class="p-4">
            <b-card-body>
              <h1> 패스워드 초기화 </h1>
                <p class="text-muted">
                  <span>비밀번호 재성정시 기존에 설정한 OTP는 초기화 됩니다.</span>
                </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                <input :disabled="reset" type="text" class="form-control" placeholder="아이디" v-model="model.username" @keyup.enter="otpToken()">
                <b-button :disabled="reset || lock_btn" variant="secondary" class="px-4" @click="otpToken()">전송</b-button>
              </b-input-group>
              <b-input-group class="mb-3" v-if="reset">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="새로운 비밀번호" v-model="model.password_new">
              </b-input-group>
              <b-input-group class="mb-3" v-if="reset">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="새로운 비밀번호 확인" v-model="model.password_new_repeat" @keyup.enter="newPassword()">
              </b-input-group>
              <hr>
              <small>
                <b-badge v-if="model.password_new"  :variant="password_policy('number') ? 'success' : 'danger'"> 숫자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> 대문자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> 소문자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('spacial') ? 'success' : 'danger'"> 특수문자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('length') ? 'success' : 'danger'">
                  최소 패스워드 길이 : {{password_meter.min_length}}
                </b-badge>
              </small>

              <b-button v-if="reset" variant="primary" class="form-control" @click="newPassword()">전송</b-button>
              <b-button class="float-left" variant="link" @click="$router.push({ name: 'auth_login'})">로그인</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
